import { Routes } from '@angular/router';
import { determineSessionRegistrationId } from 'src/app/@guards/determine-session-badge-id';
import { determineSessionStatusResolver } from 'src/app/@guards/determine-session-status.resolver';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./@pages/home/home.component').then((c) => c.HomeComponent),
  },
  {
    path: 'primary-screen',
    loadComponent: () =>
      import(
        './@pages/primary-event-projected-screens/primary-event-projected-screens.component'
      ).then((c) => c.PrimaryEventProjectedScreensComponent),
  },
  {
    path: 'event-agenda',
    loadComponent: () =>
      import('./@pages/event-agenda/event-agenda.component').then(
        (c) => c.EventAgendaComponent
      ),
  },
  {
    path: 'daily-debrief/:day',
    loadComponent: () =>
      import('./@pages/event-daily-debrief/event-daily-debrief.component').then(
        (c) => c.EventDailyDebriefComponent
      ),
  },
  {
    path: 'track-trends/:track',
    loadComponent: () =>
      import('./@pages/event-track-trends/event-track-trends.component').then(
        (c) => c.EventTrackTrendsComponent
      ),
  },
  {
    path: 'session/:sessionId',
    loadComponent: () =>
      import('./@pages/session-insights/session-insights.component').then(
        (c) => c.SessionInsightsComponent
      ),
    resolve: { sessionState: determineSessionStatusResolver },
  },
  {
    path: 'session/:sessionId/live-replay',
    loadComponent: () =>
      import('./@pages/session-live-replay/session-live-replay.component').then(
        (c) => c.SessionLiveReplayComponent
      ),
  },
  {
    path: 'session/:sessionId/debrief',
    loadComponent: () =>
      import('./@pages/session-debrief/session-debrief.component').then(
        (c) => c.SessionDebriefComponent
      ),
  },
  {
    path: 'session/:sessionId/primary-debrief',
    loadComponent: () =>
      import(
        './@pages/primary-session-debrief/primary-session-debrief.component'
      ).then((c) => c.PrimarySessionDebriefComponent),
  },
  {
    path: 'session/:sessionId/:registrationId',
    loadComponent: () =>
      import(
        './@pages/session-insights-intermediate/session-insights-intermediate.component'
      ).then((c) => c.SessionInsightsIntermediateComponent),
    resolve: { sessionState: determineSessionRegistrationId },
  },
  // TODO: @later if this route is not in use then remove it
  {
    path: 'trends/:sessionId',
    loadComponent: () =>
      import('./@pages/event-track-trends/event-track-trends.component').then(
        (c) => c.EventTrackTrendsComponent
      ),
  },
  { path: '**', redirectTo: '' },
];
